@if (!loading) {
  <ng-container *ngTemplateOutlet="content"></ng-container>
} @else {
  <app-shimmer [isLoading]="true" type="custom">
    <ng-template shimmerPreviewTemplate>
      <div class="grid-container">
        @for (i of [1]; track i) {
          <div class="cell-container grid-category">
            <div class="cell-title">
              <app-shimmer-label></app-shimmer-label>
            </div>
            <div class="cell-content">
              @for (i of [1, 2, 3, 4]; track i) {
                <div class="thumbnail-container">
                  <app-shimmer-box width="100%" height="100%"></app-shimmer-box>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>
  </app-shimmer>
}


<ng-template #content>
  <div class="grid-container">
    @for (group of groups; track group) {
      <div class="cell-container grid-category">
        <div class="cell-title">
          <span>{{ group[0] }}</span>
        </div>
        <div class="cell-content">
          @for (image of group[1]; track image) {
            <div class="thumbnail-container">
              <img
                [src]="getImageSrcUri(image)"
                class="thumbnail"
                #thumbnail
                (load)="thumbnail.setAttribute('data-image-loaded', 'true')"
                data-image-loaded="false"
                />
                @if (thumbnail.getAttribute('data-image-loaded') === 'true') {
                  <div
                    class="thumbnail-overlay"
                    >
                    <ctrl-btn icon="visibility" style="color: white"
                    (click)="onImageDisplay(image)"></ctrl-btn>
                    <ctrl-btn
                      icon="download"
                      style="color: white"
                      (click)="onImageDownload(image)"
                    ></ctrl-btn>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>
